import { render, staticRenderFns } from "./DimensionTab.vue?vue&type=template&id=a2eb8030&scoped=true"
import script from "./DimensionTab.vue?vue&type=script&lang=js"
export * from "./DimensionTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2eb8030",
  null
  
)

export default component.exports